import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {NgbModal, ModalDismissReasons, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
// import {LoginComponent} from '../login/login.component';
import {errorlist} from '../providers/errorlist';
import { User, SignupUser } from '../models/user';

import { AuthService } from '../providers/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from '../../environments/environment.prod';

import {COUNTRY} from '../providers/country';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit, OnDestroy {
  modalReference: any;
  errorlist:any;
  public signinData: User = {};
  public signup: SignupUser = {first_name: null, last_name: null, email: null, area_id: null, country_code: null, phone: null, password: null, street_address: null, apt: null, cross_street: null, term: null};
  public isCollapsed = true;
  isLogedin:boolean;
  areaData:any = [];
  country : any;

  private clickSubscriber;
 

  @ViewChild('signin')
  signin;
  @ViewChild('signupModal')
  signupModal;

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.clickSubscriber.unsubscribe();
  }
	ngOnInit() {
    this.clickSubscriber = this.auth.buttonClick$.subscribe((name) => {
      console.log("edf", name)
      if(name == 'login'){
        this.openlogin(this.signin);
      }else if(name == 'signup'){
        this.openSignup(this.signupModal);
      }
    })
    // initialize user
    this.signinData = {
      email: "",
      password: ""
    }
    this.signup = {
      first_name:"",
      last_name:"",
      email: "", 
      area_id:null,
      phone:"",
      password: "", 
      street_address:"",
      apt:"", 
      cross_street:"", 
      term:0
    }
    //assign all errorlist in 
    this.errorlist = errorlist;


    this.auth.currentLoginStatus.subscribe(status => this.isLogedin = status);
    let tokenExist = localStorage.getItem('token');
    if (tokenExist !== null) {
      this.auth.changeLoginStatus(true);
      let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    } else {
      this.auth.changeLoginStatus(false);
    }
    //get area list for signup data
    this.auth.getarea().then((area) => {
      console.log(area.json())
      this.areaData = area.json().data;
      console.log(this.areaData)
    }).catch((err) => {
      this.spinnerService.hide();
      console.log(err);
      this.auth.open(environment.error)
    });
  }
	
	toggleMenu() {
    console.log('sdfsf')
    if(this.isCollapsed){
      this.isCollapsed = !this.isCollapsed;
    }else{
      this.isCollapsed = this.isCollapsed;
    }
    
  }

  closeResult: string;
	
  constructor(private modalService: NgbModal, private auth : AuthService, private router: Router, private spinnerService: Ng4LoadingSpinnerService) {
	  this.country = COUNTRY;
	  //console.log('country' + this.country);
  }


  openlogin(content) {
    if(this.modalReference)
      this.modalReference.close();
    this.modalReference = this.modalService.open(content,  { windowClass: 'login-modal' });
  }

  openSignup(content) {
    if(this.modalReference)
      this.modalReference.close();
    this.modalReference = this.modalService.open(content,  { windowClass: 'signup-modal' });
  }

  login():void{
    this.spinnerService.show();
    this.auth.login(this.signinData).then((user) => {
      localStorage.setItem('sid', user.json().sid);
      localStorage.setItem("token", user.json().sid);
      localStorage.setItem("currentUser", JSON.stringify(user.json().data));
      let response = user.json();
      if(response.replyCode == "error"){
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
      }else{
        this.signinData = {};
        this.auth.changeLoginStatus(true);
        this.modalReference.close();
        this.spinnerService.hide();
        //this.auth.open(response.replyMsg);
        this.router.navigateByUrl('/');
      }
    })
    .catch((err) => {
      this.spinnerService.hide();
      console.log(err);
      this.auth.open(environment.error)
    });
  }
  
  lat:any= 0.00;
  lng:any = 0.00;
  location:string ="";
  userSettings = {
    "showCurrentLocation":false,
    "showSearchButton":false,
  }
  autoCompleteCallback1(selectedData:any) {
    //do any necessery stuff.
    ///console.log(selectedData);
    let geometry = selectedData.data.geometry;
    //console.log(geometry);
    if ((geometry) !== undefined) {  
      this.lat = geometry.location.lat;
      this.lng = geometry.location.lng;
    }
    this.location = selectedData.data.description; 
    //console.log('lat = '+this.lat,'lat = '+this.lng,'lat = '+this.location);
  }

  signupUser():void{
	this.signup['lat'] = this.lat;
    this.signup['lng'] = this.lng;
    this.signup['location'] = this.location;
    console.log(this.signup);
    if(this.location == ""){
      this.spinnerService.hide();
      this.auth.open("Location is required.");
    }else{
      this.spinnerService.show();
      this.auth.register(this.signup).then((register) =>{
        let response = register.json();
        if(response.replyCode == "error"){
          this.spinnerService.hide();
          this.auth.open(response.replyMsg);
        }else{
          this.signup = {};
          this.modalReference.close();
          this.spinnerService.hide();
          this.auth.open(response.replyMsg);
          this.router.navigateByUrl('/');
        }
      }).catch((err) => {
        this.spinnerService.hide();
        console.log(err);
        this.auth.open(environment.error);
      });
    }
  }

  logout(){
    this.auth.changeLoginStatus(false);
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('sid');
    this.isLogedin = false;
   this.router.navigate(['/']);
  }

  myprofile(){
    this.router.navigate(['view-profile']);
  }
  forgot_password(){
    this.modalReference.close();
    this.router.navigate(['forgot-password']);
  }
  signupopen(){
    if(this.modalReference)
      this.modalReference.close();
      this.router.navigate(['signup']);
  }
}

 


// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/header/header.component.ts